<template>
  <div>
    <!-- 微信认证组件 -->
    <wxAuth v-if="share" :share="share"></wxAuth>
    <div class="loading" style="padding-top: 50%" v-if="!isCheck">
      <van-loading type="spinner" color="#1989fa" />
    </div>
    <div v-else>
      <headers :params="hraderP" />
      <!-- 第一个头 -->
      <div class="head-1">
        <img
          src="../../../assets/images/activities/desiagner/banner.png"
          alt=""
        />
        <!-- 标题  内容 -->
        <div class="loops" style="margin-top: -105px">
          <div class="title">
            <img src="../../../assets/images/activities/desiagner/title.png" />
            <span>什么是设计师合伙人</span>
            <div class="content">
              <div class="detail">
                设计师合伙人是方案馆的重要合作伙伴，
                专业从事弱电智能化行业，有设计能力，有项目资源，
                且有意愿合作的个人（设计师，项目负责人，商务负责人等）
                或企业（设计单位，咨询公司，集成商/工程商等）
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="backage-body" style="margin-top: -25px">
        <div class="title margin">
          <img src="../../../assets/images/activities/desiagner/title.png" />
          <span style="left: 26%">如何成为设计师合伙人</span>
          <div class="content se-height">
            <!-- 设计接单 -->
            <div class="detail flex-row">
              <img
                src="../../../assets/images/activities/desiagner/sheji.png"
                alt=""
              />
              <div class="flex-column">
                <div class="quanyi-title">设计接单</div>
                <div class="quanyi-content">
                  优先承接河姆渡推送的设计业务加微信：15855446017 了解详情
                </div>
              </div>
            </div>
            <!--  -->
            <div class="detail flex-row" style="margin-top: 12px">
              <img
                src="../../../assets/images/activities/desiagner/hezuo.png"
                alt=""
              />
              <div class="flex-column">
                <div class="quanyi-title">项目合作</div>
                <div class="quanyi-content">
                  一单一议，有高额奖励<br />选择方案馆内品牌，享高额收益
                </div>
              </div>
            </div>
            <div class="detail flex-row" style="margin-top: 12px">
              <img
                src="../../../assets/images/activities/desiagner/tuijian.png"
                alt=""
              />
              <div class="flex-column">
                <div class="quanyi-title">推荐品牌</div>
                <div class="quanyi-content">
                  推荐供应商入驻方案馆品牌专区<br />享高额奖励
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="backage-body fir-height" >
        <div style="height: 8px"></div>
        <div class="title margin">
          <img src="../../../assets/images/activities/desiagner/title.png" />
          <span style="left: 26%">如何成为设计师合伙人</span>
          <div class="content fir-height-content" style="height: 300px">
            <div class="detail flex-column2">
              <div class="flex-item flex-row">
                <img
                  class="step-img"
                  src="../../../assets/images/activities/desiagner/step1.png"
                  alt=""
                />
                <div class="jian"></div>
                <div class="step-title">第一步</div>
                <div class="step-detail">在线填写资料</div>
              </div>
              <div class="flex-row flex-item">
                <img
                  class="step-img"
                  src="../../../assets/images/activities/desiagner/step2.png"
                  alt=""
                />
                <div class="jian"></div>
                <div class="step-title">第二步</div>
                <div class="step-detail">专人沟通</div>
              </div>
              <div class="flex-row flex-item">
                <img
                  class="step-img"
                  src="../../../assets/images/activities/desiagner/step3.png"
                  alt=""
                />
                <div class="jian"></div>
                <div class="step-title">第三步</div>
                <div class="step-detail">成为设计师合伙人</div>
              </div>
              <div class="flex-row">
                <img
                  class="step-img"
                  src="../../../assets/images/activities/desiagner/step4.png"
                  alt=""
                />
                <div class="jian"></div>
                <div class="step-title">第四步</div>
                <div class="step-detail">享受特权</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 点击跳转 -->
      </div>
      <div class="foot-button" @click="navigation">{{btnText}}</div>
      <div style="height: 8px"></div>
      <div class="examine-fail-modal" v-if="showFail">
        <div class="examine-fail">
          <div class="examine-fail-top">您提交的信息审核未通过</div>
          <div class="examine-fail-content">
            <div class="examine-fail-left">【原因】</div>
            <div class="examine-fail-right">{{showFail}}</div>
          </div>
          <div class="examine-fail-reset" @click="failReset">重新申请</div>
          <div class="examine-fail-no" @click="showFail = false">稍后再说</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headers from '@/components/headers'
import { getJoinStatus, checkFailMsg } from '@/api/brand/brands'
import { isMobile, toLogin, verifyLoginStatus } from '@/utils/common'
import { getCookie } from '@/utils/cookies'
import wxAuth from '@/components/wxAuth'

export default {
  name: 'index',
  components: {
    headers,
    userInfo: {},
    wxAuth,
  },
  async mounted () {
    await verifyLoginStatus()
    if (!isMobile()) {
      console.log(`${process.env.PC_SOLUTION_URL || '//solution.homedo.com'}/design/partner.html`)
      window.location.href = `${process.env.PC_SOLUTION_URL || '//solution.homedo.com'}/design/partner.html`
    }
    this.getUserInfo().then((res) => {
      this.userInfo = res
      if (+this.userInfo.AccountId) {
        this.checkExamine(this.userInfo.AccountId)
      }
    })
  },
  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.getUserInfo().then((res) => {
        if (!getCookie('ticket') && $HMD$.rNavigator !== 'msite') {
          vm.isCheck = true
          return
        } else if ($HMD$.rNavigator === 'msite' && (!getCookie('AccountId') && !getCookie('accountId'))) {
          vm.isCheck = true
          return
        }
        vm.userInfo = res
        vm.check()
      })
    })
  },
  methods: {
    checkExamine (id) {
      checkFailMsg({userId: id}).then((res) => {
        if (res.data && res.data.data && res.data.data.alertFlag) {
          this.showFail = res.data.data.message || ''
        }
      })
    },
    failReset () {
      this.showFail = false
      this.navigation()
    },
    navigation () {
      if (!getCookie('ticket') && $HMD$.rNavigator !== 'msite') {
      // 跳转登录页面
        toLogin()
        return
      } else if ($HMD$.rNavigator === 'msite' && (!getCookie('AccountId') && !getCookie('accountId'))) {
        toLogin()
        return
      }
      getJoinStatus(this.userInfo.AccountId).then((res) => {
        let { status, data } = res
        if (status == 200) {
          let { respCode, respDesc } = data
          if (respCode == '0000') {
            if (data.data.status == 0) {
              this.$toast('审核中，请耐心等待')
            }
            if (data.data.status == 1) {
              this.$router.push('/activity/dsg/randi.html')
            }
            if (data.data.status > 1) {
              if (this.$route.query.recommendId) {
                this.$router.push(`/activity/dsg/apply.html?recommendId=${this.$route.query.recommendId}`)
              } else {
                this.$router.push('/activity/dsg/apply.html')
              }
            }
          }
        }
      })
    },
    check () {
      getJoinStatus(this.userInfo.AccountId).then((res) => {
        this.isCheck = true
        let { status, data } = res
        if (status == 200) {
          let { respCode, respDesc } = data
          if (respCode == '0000') {
            if (data.data.status == 1) {
              this.$router.push('/activity/dsg/randi.html')
            }
            if (data.data.status == 0) {
              this.btnText = '审核中'
            }
          }
        }
      })
    },
    async getUserInfo () {
      return new Promise((resolve, reject) => {
        $HMD$.GetLogin(function (data) {
          resolve(data)
        })
      })
    }
  },
  data () {
    return {
      hraderP: {
        title: '设计师合伙人'
      },
      isCheck: false,
      btnText: '立刻申请',
      showFail: false,
      share: {
        title: '解决方案馆',
        desc: '智能化产品方案,产品方案,系统方案,弱电设备方案,厂商方案,产品供应商设计方案,弱电设计方案,热门方案,规划设计方案,顶层设计方案,系统解决方案,集成商方案,招标方案,投标方案,深化设计方案,施工方案',
        imgUrl: 'https://image01.homedo.com/Files/Images/cms/www/20171225/4970465306687879653_pic1.jpg',
        url: window.location.href.split('#')[0]
      },
    }
  }
}
</script>

<style scoped>
.examine-fail-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,.7);
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
}
.examine-fail {
  width: 270px;
  background: #ffffff;
  border-radius: 8px;
  padding-bottom: 16px;
}
.examine-fail-top {
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1e1f22;
  font-size: 17px;
  font-weight: bold;
  border-bottom: 1px solid #eeeeee;
}
.examine-fail-content {
  padding: 12px 33px 20px 21px;
  display: flex;
}
.examine-fail-left {
  width: 48px;
  font-size: 12px;
  color: #aaaaaa;
  line-height: 21px;
  flex-shrink: 0;
  text-align: center;
}
.examine-fail-right  {
  flex: 1;
  font-size: 14px;
  color: #222222;
  line-height: 18px;
}
.examine-fail-reset {
  width: 192px;
  height: 36px;
  background: #2f7bff;
  border-radius: 18px;
  margin: 0 auto;
  font-size: 14px;
  color: #FFF;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 36px;
}
.examine-fail-no {
  width: 60px;
  height: 17px;
  font-size: 12px;
  margin: 8px auto 0;
  text-align: center;
  color: #AAAAAA;
  font-size: 12px;
}
.head-1 {
  width: 375px;
  height: 310px;
  background: rgba(46, 123, 255, 1);
}
.head-1 img {
  width: 375px;
  height: 201px;
  z-index: -1;
}
.loops {
  margin: 0 auto;
  width: 325px;
  height: 157px;
  background: #fff;
}
.title {
  width: 325px;
  height: 38px;
  text-align: center;
  line-height: 28px;
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  position: relative;
}
.title img {
  width: 325px;
  height: 38px;
}
.title span {
  position: absolute;
  top: 2px;
  left: 29%;
}
.content {
  width: 325px;
  height: 138px;
  background: #fff;
  top: 37px;
  left: 0;
  position: absolute;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
.detail {
  color: rgba(34, 34, 34, 1);
  width: 235px;
  height: 100px;
  background: rgba(47, 123, 255, 0.09);
  border-radius: 8px;
  margin: 0 auto;
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  padding: 12px 25px;
  text-align: justify;
}
.detail img {
  width: 60px;
  height: 60px;
}
.margin {
  margin: 0 auto;
}
.backage-body {
  margin-top: -3px;
  width: 100%;
  height: 350px;
  background: rgba(46, 123, 255, 1);
  padding-top: 10px;
}
.flex-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 65px;
  position: relative;
}
.flex-row .step-img {
  width: 44px;
  height: 44px;
}
.flex-row .jian {
  width: 15px;
  margin-left: 12px;
  background: url("../../../assets/images/activities/desiagner/arrow.png") 100%
    100% no-repeat;
  background-size: 100%;
  height: 15px;
  margin-right: 12px;
}
.flex-row .step-title {
  font-size: 12px;
  font-weight: 400;
  color: #000b2f;
  width: 70px;
}
.flex-row .step-detail {
  width: 90px;
  font-size: 12px;
  white-space: nowrap;
  color: #545454;
  margin-left: -12px;
}
.flex-column {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: space-between;
  margin-left: 11px;
}
.flex-column2 {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: space-between;
  height: 260px;
}
.quanyi-title {
  font-size: 15;
  font-weight: 400;
  color: #000b2f;
}
.quanyi-content {
  font-size: 12px;
  font-weight: 400;
  color: #6e6e6e;
  width: 170px;
}
.foot-button {
  width: 311px;
  height: 44px;
  background: #2f7bff;
  text-align: center;
  line-height: 44px;
  color: #fff;
  font-size: 15px;
  font-weight: 400;
  border-radius: 26px;
  margin: 8px auto;
}
.loading {
  margin: 0 auto;
  width: 60px;
  height: 60px;
}
.flex-item::after {
  position: absolute;
  left: 21px;
  top: 53px;
  content: "";
  background: url("../../../assets/images/activities/desiagner/line.png") 100%
    100% no-repeat;
  background-size: 100% 100%;
  width: 1px;
  height: 22px;
  z-index: 0;
}
.se-height{
  height: 310px !important;
}
.fir-height{
  height: 366px;
}
.fir-height-content{
  height: 300px !important;
}
</style>



// WEBPACK FOOTER //
// src/view/activities/designer/index.vue